import { render, staticRenderFns } from "./CRButton.vue?vue&type=template&id=478d6078&"
import script from "./CRButton.vue?vue&type=script&lang=js&"
export * from "./CRButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports